module.exports = __webpack_public_path__ + "static/media/404a.96084126.png";